import React from 'react'

export default function UpcomingAnimeMap({ animeUpcoming }) {
  return (
    <div key={animeUpcoming.mal_id} className="center">
    <h2 className='heading'>{animeUpcoming.title_english}</h2>
    <img className='img' src={animeUpcoming.images.jpg.large_image_url} alt={animeUpcoming.title} />
   </div>
  )
}

